export const activeFilterCount = ({
    currentActive,
    filterHeading,
}: {
    currentActive: number;
    filterHeading: HTMLElement;
}) => {
    if (!filterHeading) return;

    const baseHeading = filterHeading.innerHTML.replace(/ \(\d+\)$/, "");
    filterHeading.innerHTML =
        currentActive > 0 ? `${baseHeading} (${currentActive})` : baseHeading;
};
